export default __webpack_public_path__ + "static/media/V420_CoC.f61d2993.pdf";